/**
 * Vendor module route definitions.
 *
 * `role` is kept for backward compatibility; `permission` is the primary
 * access check used by ProtectedRoute.
 */
import React from 'react';

import VendorDashboard from './pages/VendorDashboard';
import InvoiceUpload from './pages/InvoiceUpload';
import PaymentHistory from './pages/PaymentHistory';
import VendorProfileSettings from './pages/VendorProfileSettings';

const vendorRoutes = [
  { path: '/vendor/dashboard',  element: <VendorDashboard />,       role: 'vendor', permission: ['marketplace.view', 'farmer.dashboard'] },
  { path: '/vendor/orders',     element: <VendorDashboard />,       role: 'vendor', permission: 'marketplace.view' },
  { path: '/vendor/invoices',   element: <InvoiceUpload />,         role: 'vendor', permission: 'marketplace.manage' },
  { path: '/vendor/payments',   element: <PaymentHistory />,        role: 'vendor', permission: ['marketplace.view', 'credit.escrow.view'] },
  { path: '/vendor/profile',    element: <VendorProfileSettings />, role: 'vendor', permission: ['marketplace.view', 'farmer.dashboard'] },
];

export default vendorRoutes;
